module.exports = __webpack_public_path__ + "static/media/zoomin.8fe18202.svg";